<template>
	<div>
		<p class="pb-3">
			{{label}}
		</p>	
			
	  	<ul v-if="TypeElement">
	  		<li class="mb-2" v-for="(option, index) in getOptions" :key="index">
	  			<input style="width: 20px; height: 20px" :disabled="disabled" type="radio" :id="`${option}_${index}`" :value="option" v-model="answerSend"> 
	  			<label class="ml-3" :for="`${option}_${index}`">{{option}}</label> 
	  			<!-- <vs-radio color="success" :disabled="disabled"  v-model="answerSend" :vs-value="option">
	  				<p class="truncated-multi">
	  					{{option}}
	  				</p>
	  			</vs-radio>	 -->  	     	
	  	   </li>
	  	</ul>

	  	<ul v-else>
	  		<li class="mb-2" v-for="(option, index) in getOptions" :key="index">	  			
	  			<input style="width: 20px; height: 20px" :disabled="disabled" type="radio" :id="`${option}_${index}`" :value="option.value" v-model="answerSend"> 
	  			<label class="ml-3" :for="`${option}_${index}`">{{option.text}}</label> 
	  			<!-- <vs-radio color="success" :disabled="disabled"  v-model="answerSend" :vs-value="option">
	  				<p class="truncated-multi">
	  					{{option}}
	  				</p>
	  			</vs-radio>	 -->  	     	
	  	   </li>
	  	</ul>	  	
	</div>
</template>

<script type="text/javascript">
	import { mapState, mapMutations } from 'vuex';
	export default {
		props: {
			label: {
				type: String,
				required: false,
				default: 'Descripción'
			},
			answer: {
				type: [String, Array, Boolean],
				required: false,
				default: ''
			},
			disabled: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data() {
			return {
				value: '',
				options: [],
			}
		},
		methods: {

		},	
		computed: {
			...mapState('resource', ['indexQuestion', 'questionsByPage', 'activePopup', 'optionsDependencies']),
			answerSend: {
				get() {						
					return this.answer ;
				},
				set(value) {
					this.$emit('input', value);
				}
			},		
			TypeElement() {				
				if(this.optionsDependencies.length > 0) {
					const firstElement = this.optionsDependencies[0];
					if(typeof(firstElement) === 'string') return true;
					return false;
				}
				return true;
			},
			getOptions() {
				return this.optionsDependencies;
			}
		}
		
	}
</script>

<style type="text/css">
	.truncated-multi {
		width: 300px;
		white-space: nowrap;
	  	overflow: hidden;
	  	text-overflow: ellipsis;
	}
	@media only screen and (max-width: 768px) {
		.truncated-multi {
			width: 200px;			
		}
	}
</style>